import { baseApi } from "../redux/baseAPI";

export const lettersOrdersApi = baseApi.injectEndpoints({
  tagTypes: ["LettersList", "ClinicalTemplates", "PreviewTemplate"],
  endpoints: (builder) => ({
    getLetters: builder.query({
      query: (queryParams) => {
        return {
          url: `/ClinicalTemplate/get_letters.json`,
          method: "GET",
          params: queryParams,
          // pid
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
      providesTags: ["LettersList"],
    }),
    getClinicalTemplates: builder.query({
      query: (queryParams) => {
        return {
          url: `/ClinicalTemplate/list.json`,
          method: "GET",
          params: queryParams,
          // is_active = 1
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ["ClinicalTemplates"],
    }),
    getPreviewTemplates: builder.query({
      query: (queryParams) => {
        return {
          url: `/ClinicalTemplate/preview_template.json`,
          method: "GET",
          params: queryParams,
          // is_active = 1
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
      providesTags: ["PreviewTemplate"],
    }),
    getDocumentComments: builder.query({
      query: (params) => {
        return {
          url: `/documents/get_comments.json`,
          method: "GET",
          params: params,
          // doc_id, pid
        };
      },
      transformResponse: (response, meta, arg) => response?.response?.data,
    }),
    getSignatures: builder.query({
      query: (params) => {
        return {
          url: `/efax/get_signatures.json`,
          method: "GET",
          params: params,
        };
      },
      transformResponse: (response, meta, arg) => response.response.data,
    }),
    signLetter: builder.mutation({
      query: (data) => {
        return {
          url: `/ClinicalTemplate/sign_letter.json`,
          method: "POST",
          data: data,
        };
      },
      transformResponse: (response, meta, arg) => response.response,
      invalidatesTags: ["LettersList"],
    }),
  }),
});

export const {
  useGetLettersQuery,
  useGetClinicalTemplatesQuery,
  useGetPreviewTemplatesQuery,
  useSignLetterMutation,
  useGetDocumentCommentsQuery,
  useGetSignaturesQuery,
} = lettersOrdersApi;
